export const HEX_REGEX = /^(?:#)?((?:[0-9a-f]{2}){3,4})$/i;
export const SHORT_HEX_REGEX = /^(?:#)?((?:[0-9a-f]){3})$/i;
export const RGB_REGEX = /^(?:rgb|rgba)\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})(?:\s*,\s*(1|0|(?:0?\.[0-9]+)))?\s*\)$/i;
